/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Redirect, useParams, useLocation, useHistory, Link } from 'react-router-dom';
import $ from 'jquery';
import {
  FaThLarge,
  FaUsers,
  FaEnvelope,
  FaUserPlus,
  FaTags,
  FaShieldAlt,
  FaArrowLeft,
} from 'react-icons/fa';
import { ROUTES, setElementHeights } from '../../assets/constants/strings';
import ApiHeader from '../../components/API/UIElements/Header';
import Footer from '../../components/Footer';
import Overview from '../../components/API/Admin/Overview';
import Enquiries from '../../components/API/Admin/Enquiries';
import Customers from '../../components/API/Admin/Customers';
import CustomerDetail from '../../components/API/Admin/CustomerDetail';
import ProvisionWizard from '../../components/API/Admin/ProvisionWizard';
import Plans from '../../components/API/Admin/Plans';
import { isSuperAdmin, isAuthenticated } from '../../services/entitlements';
import '../../components/API/Admin/style.scoped.scss';

const mapStateToProps = (state) => ({
  user: state.user.user,
});

const connector = connect(mapStateToProps, null);

// Dashboard sections, one per route: /api/admin/<url>. Customers is the single list across both
// products — narrowing to one product is a filter on that page, not a section of its own. Enquiries
// and Provisioning both span the two products, so nothing here is grouped by product.
const NAV_GROUPS = [
  {
    heading: null,
    items: [
      { url: 'overview', label: 'Overview', icon: <FaThLarge />, title: 'Admin Dashboard' },
      { url: 'customers', label: 'Customers', icon: <FaUsers />, title: 'Customers' },
      { url: 'enquiries', label: 'Enquiries', icon: <FaEnvelope />, title: 'Enquiries' },
      { url: 'provision-trial', label: 'Provisioning', icon: <FaUserPlus />, title: 'Provision customer' },
      { url: 'plans', label: 'Plans & limits', icon: <FaTags />, title: 'Plans & limits' },
    ],
  },
];

const ALL_NAV = NAV_GROUPS.flatMap((g) => g.items);

// The Customers, Subscribers, Organisations and API-customers sections all folded into this one
// list; keep their URLs working so existing links and bookmarks still land somewhere sensible.
const LEGACY_PAGES = {
  accounts: 'customers',
  reader: 'customers',
  organisations: 'customers',
  'api-customers': 'customers',
};

// Internal admin dashboard (/api/admin). SuperAdmin-only — the admin API endpoints are also
// enforced server-side, so this is UX gating.
const ApiAdmin = ({ user }) => {
  const { page, id } = useParams();
  const location = useLocation();
  const history = useHistory();
  const requested = LEGACY_PAGES[page] || page;
  const active = ALL_NAV.some((t) => t.url === requested) ? requested : 'overview';
  const current = ALL_NAV.find((t) => t.url === active);
  // /api/admin/customers/:id is one customer's own page.
  const customerId = active === 'customers' && id ? parseInt(id, 10) : null;
  // The retired API-customers URL keeps the filter it used to apply.
  const legacyApiFilter = page === 'api-customers' ? 'api' : undefined;

  useEffect(() => {
    $(window).on('resize', setElementHeights);
  }, []);

  // Keep the vertical scrollbar reserved while on the admin route, so switching between sections of
  // different heights doesn't shift the layout. Reverted on unmount so other pages are unaffected.
  useEffect(() => {
    const el = document.getElementById('wf-scroll-wrapper');
    if (el) el.classList.add('adm-scrolllock');
    return () => {
      if (el) el.classList.remove('adm-scrolllock');
    };
  }, []);

  useEffect(() => {
    document.title = 'Admin | RegulationCity';
    setElementHeights();
  });

  if (!isAuthenticated(user)) {
    return <Redirect to={`${ROUTES.LOGIN}?portal=api`} />;
  }

  if (user && !isSuperAdmin(user)) {
    return <Redirect to={ROUTES.APIHOME} />;
  }

  return (
    <div className='wf-doc-wrapper w-100 adm-page' id='wf-doc-page'>
      <nav id='sticky-top-wrapper' className='navbar sticky-top p-0'>
        <div className='w-100 d-flex flex-column '>
          <ApiHeader hasNav />
        </div>
      </nav>

      <main role='main' className='wf-document adm-main px-0 mb-0' id='wf-my-account'>
        <div className='adm-layout'>
          <aside className='adm-nav'>
            <div className='adm-nav__brand'>
              <span className='adm-nav__brand-mark'>
                <FaShieldAlt />
              </span>
              <div>
                <div className='adm-nav__brand-title'>Admin Console</div>
                <div className='adm-nav__brand-sub'>RegulationCity</div>
              </div>
            </div>
            <nav>
              {NAV_GROUPS.map((g, gi) => (
                <div className='adm-nav__section' key={g.heading || `top-${gi}`}>
                  {g.heading && <div className='adm-nav__group'>{g.heading}</div>}
                  {g.items.map((t) => (
                    <Link
                      key={t.url}
                      to={`${ROUTES.APIAdmin}/${t.url}`}
                      className={`adm-nav__item${active === t.url ? ' is-active' : ''}`}
                    >
                      <span className='adm-nav__icon'>{t.icon}</span>
                      <span>{t.label}</span>
                    </Link>
                  ))}
                </div>
              ))}
            </nav>
            <div className='adm-nav__foot'>
              <Link to={ROUTES.APIHOME} className='adm-nav__foot-link'>
                <FaArrowLeft /> Back to site
              </Link>
            </div>
          </aside>

          <div className='adm-content'>
            <header className='adm-content__head'>
              <h1 className='adm-content__title'>{current.title}</h1>
            </header>

            {active === 'overview' && <Overview />}
            {active === 'customers' &&
              (customerId ? (
                <CustomerDetail
                  key={customerId}
                  clientId={customerId}
                  onBack={() => history.push(`${ROUTES.APIAdmin}/customers`)}
                />
              ) : (
                <Customers product={legacyApiFilter} />
              ))}
            {active === 'plans' && <Plans />}
            {active === 'enquiries' && <Enquiries />}
            {active === 'provision-trial' && (
              <ProvisionWizard
                key={location.state && location.state.prefill ? location.state.prefill.enquiryId : 'blank'}
                prefill={location.state ? location.state.prefill : undefined}
              />
            )}
          </div>
        </div>
      </main>
      <Footer isDocument isCentered isAbsolute />
    </div>
  );
};

export default connector(ApiAdmin);
